module.exports = __webpack_public_path__ + "img/performance-work-icon7.5d22721f.png";